var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4419 7.07459C15.1979 6.80847 14.8021 6.80847 14.5581 7.07459L10.4419 11.5625C10.1979 11.8286 9.80214 11.8286 9.55806 11.5625L5.44194 7.07459C5.19786 6.80847 4.80214 6.80847 4.55806 7.07459C4.31398 7.34072 4.31398 7.77219 4.55806 8.03831L8.67418 12.5262C9.40641 13.3246 10.5936 13.3246 11.3258 12.5262L15.4419 8.03831C15.686 7.77219 15.686 7.34072 15.4419 7.07459Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.aa2843bf1fe86c595080b0a1030e7ee0.svg";
export { ForwardRef as ReactComponent };